module.exports = __webpack_public_path__ + "fonts/icomoon.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icomoon/icomoon.ttf
// module id = e9Oj
// module chunks = 1